export const SET_SELECTED_COLUMNS = 'SET_SELECTED_COLUMNS';

export const setSelectedColumns = (tableId, selectedColumns) => ({
  type: SET_SELECTED_COLUMNS,
  payload: { tableId, selectedColumns },
});

